export default {"src":"/_next/static/media/powerOffIcon.9a0af662.svg","height":27,"width":25,"blurWidth":0,"blurHeight":0};